import Link from 'antd/lib/typography/Link';

const TextLinkAtom = Link;

export default TextLinkAtom;
